import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogService, ConfirmDialogData } from './confirm-dialog.service';

@Component({
  selector: 'lib-confirm-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  @Input() dialog!: ConfirmDialogData;
  private readonly confirmDialogService = inject(ConfirmDialogService);

  confirm(): void {
    this.confirmDialogService.confirmDialog(this.dialog.id);
  }

  cancel(): void {
    this.confirmDialogService.cancelDialog(this.dialog.id);
  }

  confirmClass(): string {
    return this.dialog.confirmButtonType === 'danger'
      ? 'button button-danger'
      : 'button button-primary';
  }
}
